export default {
    //西班牙语
    DiagnosticReport:'Informe de diagnóstico',
    troubleCode:'Código de falla',
    time:'Tiempo',
    noTItle:'Control del fabricante',
    TestReport:'Informe de prueba',
    VehicleInformation:'Información del Vehículo',
    DataStream:'Flujo de datos',
    IMReadiness:'I/M Preparación',
    Communication:'Protocolo de comunicación',
    notFaultCode:'Sin Código de falla',
    nodataflow:'No hay flujo de datos anormal',
    // 语言
    lang:{
        cn:'Chino',
        de:'Alemán',
        en:'Inglés',
        es:'Español',
        fr:'Francés',
        it:'Italiano',
        ja:'Japonés',
        ko:'Coreano',
        pt:'Portugués'
    }
}